import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-secondary-900 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div>
              <Link to="/" className="flex items-center gap-2 text-background-50 mb-4">
                <div className="w-8 h-8 flex items-center justify-center">
                  <i className="ri-book-read-line text-xl"></i>
                </div>
                <span className="text-lg font-bold font-heading whitespace-nowrap">免费漫画网</span>
              </Link>
              <p className="text-sm text-secondary-300 leading-relaxed">
                正版韩漫大全，免费韩漫下拉式阅读平台。内容合法、画质优越，为您提供最优质的在线漫画阅读体验。
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#quick-links" className="hover:text-primary-300 transition-colors">快速链接</a>
              </h4>
              <ul className="space-y-2.5">
                <li><Link to="/" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">首页</Link></li>
                <li><Link to="/category/all" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">全部漫画</Link></li>
                <li><Link to="/category/all?sort=rating" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">排行榜</Link></li>
                <li><Link to="/about" className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">关于我们</Link></li>
              </ul>
            </div>

            {/* Categories */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#categories" className="hover:text-primary-300 transition-colors">热门分类</a>
              </h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 6).map((cat) => (
                  <li key={cat.slug}>
                    <Link to={`/category/${cat.slug}`} className="text-sm text-secondary-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                      {cat.name}漫画
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm font-semibold text-background-50 mb-4">
                <a href="#contact" className="hover:text-primary-300 transition-colors">联系我们</a>
              </h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-mail-line text-xs"></i>
                  </div>
                  <span>contact@freemanhua.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-map-pin-line text-xs"></i>
                  </div>
                  <span>中国北京市</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-secondary-300">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-customer-service-line text-xs"></i>
                  </div>
                  <span>在线客服：工作日 9:00-18:00</span>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-12 pt-6 border-t border-secondary-700/50">
            <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
              <p className="text-xs text-secondary-400">
                &copy; {currentYear} 免费漫画网 - 正版韩漫大全. All rights reserved.
              </p>
              <div className="flex items-center gap-4 text-xs text-secondary-400">
                <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap" rel="nofollow">用户协议</a>
                <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap" rel="nofollow">隐私政策</a>
                <a href="#" className="hover:text-primary-300 transition-colors whitespace-nowrap" rel="nofollow">版权声明</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}